function getPDF() {
  const HOST = window.location.origin;
  return `${HOST}/assets/pdf/Auslan_Online_Terms_And_Conditions_DSQ.pdf`;
}

export function getTermsConditionUrl() {
  const HOST = window.location.origin;
  switch (HOST) {
    case 'https://auslanconnections.vicdeaf.com.au':
    case 'https://auslanconnections.expression.com.au':
      return 'https://expression.com.au/ac-service-agreement';
    default:
      return getPDF();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/terms-condition.ts